
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { TTTFollowUpModel } from '../models/TTTFollowUpModel';
import { LocalStorageService } from 'ngx-webstorage';
import { URLsConfig } from '../URLsConfig';
@Injectable()
export class TTTFollowUpService {
  constructor(private http: HttpClient, public urlsconfig: URLsConfig) {}

  public AddTTTFollowUp(TTTFollowUp: TTTFollowUpModel) {

    return this.http.post<TTTFollowUpModel>(this.urlsconfig.WebAPIURL_Test + 'api/TTTFollowUp/AddTTTFollowUp',TTTFollowUp);
  }
public GetTTTFollowUp(pacode: string ) {
    let params = new HttpParams();
      params = params.append("PaCode", pacode);

      const options = {params: params};
      return this.http.get<TTTFollowUpModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/TTTFollowUp/GetTTTFollowUp',options);
  }
  public DelTTTFollowUp(pacode: string,tttdate: string ) {

    let params = new HttpParams();
      params = params.append("PaCode", pacode);
      params = params.append("TTTDate", tttdate);
      const options = {
        params: params
    };
    return this.http.get<TTTFollowUpModel>(this.urlsconfig.WebAPIURL_Test + 'api/TTTFollowUp/DeleteTTTFollowUp',options);
  }



}
